import { render, staticRenderFns } from "./campaignPage.vue?vue&type=template&id=034d0b98&"
import script from "./campaignPage.vue?vue&type=script&lang=js&"
export * from "./campaignPage.vue?vue&type=script&lang=js&"
import style0 from "./campaignPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports